import { lazy } from 'react';

// project-imports
import GuestGuard from 'utils/route-guard/GuestGuard';
import CommonLayout from 'layout/CommonLayout';
import Loadable from 'components/Loadable';

// render - login
const AuthLogin = Loadable(lazy(() => import('pages/auth/auth1/login')));
const AuthRegister = Loadable(lazy(() => import('pages/auth/auth1/register')));
const AuthForgotPassword = Loadable(lazy(() => import('pages/auth/auth1/forgot-password')));
const AuthCheckMail = Loadable(lazy(() => import('pages/auth/auth1/check-mail')));
const AuthResetPassword = Loadable(lazy(() => import('pages/auth/auth1/reset-password')));
const AuthCodeVerification = Loadable(lazy(() => import('pages/auth/auth1/code-verification')));
const AuthSignInOtp = Loadable(lazy(()=> import('pages/auth/auth1/AdminMobileverify')));

// ==============================|| AUTH ROUTES ||============================== //

const LoginRoutes = {
  path: '/',
  children: [
    {
      path: '/',
      element: (
        <GuestGuard>
          <CommonLayout />
        </GuestGuard>
      ),
      children: [
        // {
        //   path: '/',
        //   element: <AuthLogin />
        // },
        {
          path: 'GPMofpXek',
          element: <AuthLogin />
        },
        {
          path: 'GPMofpXek/register',
          element: <AuthRegister />
        },
        {
          path: 'GPMofpXek/forgot-password',
          element: <AuthForgotPassword />
        },
        {
          path: 'GPMofpXek/check-mail',
          element: <AuthCheckMail />
        },
        {
          path: 'GPMofpXek/reset-password/:userId',
          element: <AuthResetPassword />
        },
        {
          path: 'GPMofpXek/code-verification',
          element: <AuthCodeVerification />
        },
        {
          path: 'GPMofpXek/send-mobile-otp',
          element: <AuthSignInOtp />
        }
      ]
    }
  ]
};

export default LoginRoutes;
